const SUBMIT_STATES = {
  ERROR: 'error',
  DEFAULT: 'default',
  COMPLETE: 'complete',
  PENDING: 'pending',
};

export default SUBMIT_STATES;
